const test = () => {
    // console.log('test');
};

test();
